import { XS_VIEWPORT } from '@constants/viewport';
import { useWindowSize } from '@hooks/use-window-size';
import classNames from 'classnames';

import { SquaredTabProps } from '../../tabs.type';

export const SquaredTab = ({ name, id, showBackground, activeTab, onChange }: SquaredTabProps) => {
  const isMobileViewport = useWindowSize(XS_VIEWPORT as number);

  return (
    <button
      key={name}
      type='button'
      className={classNames(
        'text-subtitle-s whitespace-nowrap py-3 px-4 rounded-sm justify-start items-center text-left',
        {
          'fill-secondary text-tertiary': id !== activeTab && showBackground,
          'fill-primary text-primary': id === activeTab && showBackground,
          'fill-secondary text-tertiary hover:text-primary': id !== activeTab && !showBackground,
          'fill-tertiary text-primary': (id === activeTab && !showBackground) || isMobileViewport,
        }
      )}
      onClick={() => onChange(id)}>
      {name}
    </button>
  );
};
